export const errorList = [
    "CurrentFacilityState",
    "CurrentFacilityDistrict",
    "CurrentFacilityTBU",
    "CurrentFacilityPHI",
    "CurrentFacilityPHIType",
    "IsCurrent_Spectrum_HWC",
    "DiagnosingFacilityState",
    "DiagnosingFacilityDistrict",
    "DiagnosingFacilityTBU",
    "DiagnosingFacilityPHI",
    "IsDiagnosing_Spectrum_HWC",
    "DiagnosingFacilityPHIType",
    "EpisodeID",
    "PatientName",
    "PrimaryPhone",
    "Microbiologically_Confirmed",
    "Valid_result_for_Rif_available_via_DRT",
    "Rif_Resistance_Detected",
    "Rif_resistance_not_detected",
    "Age",
    "Gender",
    "TypeOfCase",
    "SiteOfDisease",
    "HIV_Status",
    "DateOf_TB_Treatment_Initiation",
    "EnrollmentFacilityState",
    "EnrollmentFacilityDistrict",
    "EnrollmentFacilityTBU",
    "EnrollmentFacilityPHI",
    "Residential_State",
    "Residential_District",
    "Residential_TU",
    "Height",
    "Weight",
    "DiabetesStatus",
    "EPSite",
    "Enrolled_by_Medical_College",
    "Diagnosed_by_Medical_College",
    "Current_facility_in_Medical_College",
    "IngenID",
];
